export default __webpack_public_path__ + "static/media/mx.4cabc972.svg";